import React from 'react';
import { LuChevronRight } from 'react-icons/lu';
import { cn, Skeleton } from '../../components/ui';

interface RowButtonProps {
  /** Iniciais ou ícone, no círculo (ou quadrado) da cor da marca. */
  avatar: React.ReactNode;
  square?: boolean;
  title: string;
  subtitle?: React.ReactNode;
  onClick: () => void;
}

const ROW = 'flex w-full items-center gap-3.5 rounded-card border border-line bg-surface px-4 py-3.5 text-left shadow-raised';

/** Linha clicável das listas de pacientes e de pedidos. */
export const RowButton: React.FC<RowButtonProps> = ({ avatar, square, title, subtitle, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(ROW, 'transition-all duration-fast ease-out hover:-translate-y-px hover:border-primary-line hover:shadow-card focus-visible:outline-none focus-visible:shadow-focus')}
  >
    <span className={cn('grid h-11 w-11 shrink-0 place-items-center bg-primary-soft font-bold text-primary', square ? 'rounded-control' : 'rounded-full')}>
      {avatar}
    </span>
    <span className="min-w-0 flex-1">
      <strong className="block truncate font-semibold">{title}</strong>
      {subtitle && <span className="block truncate text-caption text-fg-muted">{subtitle}</span>}
    </span>
    <LuChevronRight size={20} aria-hidden className="shrink-0 text-primary" />
  </button>
);

export const RowSkeletons: React.FC = () => (
  <>
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} className={ROW} aria-hidden>
        <Skeleton className="h-11 w-11 rounded-full" />
        <div className="flex flex-1 flex-col gap-2">
          <Skeleton className="h-3.5 w-5/12" />
          <Skeleton className="h-2.5 w-7/12" />
        </div>
      </div>
    ))}
  </>
);
